import React from "react";
import { Select } from "antd";
import { ToothSample, User } from "./models";
import moment from "moment";
import Icon from "@ant-design/icons";
import { getAllSamples } from "./api/Api";

export const strDate = (str: string) => {
  let ss = str.split(" ");
  let dstr = ss[0];
  let dss = dstr.split("-");
  return new Date(parseInt(dss[0]), parseInt(dss[1]) - 1, parseInt(dss[2]));
};
export const dateStr = (date: Date) => {
  let s = date.getFullYear() + "-";
  let m = date.getMonth() + 1;
  if (m < 10) {
    s += "0" + m;
  } else {
    s += m;
  }
  s += "-";
  let d = date.getDate();
  if (d < 10) {
    s += "0" + d;
  } else {
    s += d;
  }
  s += " ";
  let h = date.getHours();
  if (h < 10) {
    s += "0" + h;
  } else {
    s += h;
  }
  s += ":";
  let mm = date.getMinutes();
  if (mm < 10) {
    s += "0" + mm;
  } else {
    s += mm;
  }
  s += ":";
  let ss = date.getSeconds();
  if (ss < 10) {
    s += "0" + ss;
  } else {
    s += ss;
  }
  return s;
};

export const getTableScroll = () => {
  let tHeader = document.getElementsByClassName("ant-table-thead")[0];
  //let tHeaderBottom = tHeader.getBoundingClientRect().bottom;
  let tHeaderBottom = 300;
  let height = `calc(100vh - ${tHeaderBottom + 74}px)`;
  return height;
};

export const getSex = (isMale: boolean) => {
  if (isMale) {
    return "男";
  } else {
    return "女";
  }
};

export const getUserName = (id: number, us: User[]) => {
  let u: User | undefined = us.find((u) => u.id === id);
  if (typeof u === "undefined") {
    return "";
  } else {
    return u.userName;
  }
};
export const getC1Str = (c1: number) => {
  if (c1 === 1) {
    return "高";
  } else if (c1 === 2) {
    return "中";
  } else {
    return "低";
  }
};
export const getStatusStr = (status: number) => {
  if (status === 0) {
    return "初始化";
  } else if (status === 1) {
    return "已填报";
  } else if (status === 2) {
    return "已检查";
  } else if (status === 3) {
    return "已检测";
  }
  return "";
};

export const getResultStr = (result: number) => {
  if (result === 2) {
    return "高风险";
  } else if (result === 1) {
    return "中风险";
  } else if (result === 0) {
    return "低风险";
  }
  return "";
};

export const removeById = (arr: any[], id: number) => {
  let arr1 = [...arr];
  let idx = arr1.findIndex((a) => a.id === id);
  if (idx === -1) {
    return arr1;
  } else {
    arr1.splice(idx, 1);
    return arr1;
  }
};

export const updateByObj = (arr: any[], obj: any) => {
  let arr1 = [...arr];
  return arr1.map((a) => {
    if (a.id === obj.id) {
      return obj;
    } else {
      return a;
    }
  });
};

const HospitalSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2432"
    width="16"
    height="16"
  >
    <path
      d="M967.0656 451.1744H838.5536V321.2288a35.84 35.84 0 0 0-35.84-35.84h-31.9488V67.1744h32.4608a15.36 15.36 0 1 0 0-30.72H212.6848a15.36 15.36 0 0 0 0 30.72h32.4608v384H55.7056a35.84 35.84 0 0 0-35.84 35.84v493.2608a35.84 35.84 0 0 0 35.84 35.84h911.36a35.84 35.84 0 0 0 35.84-35.84V487.0144a35.84 35.84 0 0 0-35.84-35.84z m-163.84-135.0656a5.12 5.12 0 0 1 5.12 5.12v129.9456h-37.5808V316.1088zM212.2752 985.3952V778.24h-30.72v207.1552H55.7056a5.12 5.12 0 0 1-5.12-5.12V487.0144a5.12 5.12 0 0 1 5.12-5.12h189.44v503.5008z m217.1904 0V766.0544a5.12 5.12 0 0 1 5.12-5.12h146.7392a5.12 5.12 0 0 1 5.12 5.12v219.3408z m187.6992 0V766.0544a35.84 35.84 0 0 0-35.84-35.84H434.5856a35.84 35.84 0 0 0-35.84 35.84v219.3408h-122.88V67.1744h464.1792v918.2208z m355.0208-5.12a5.12 5.12 0 0 1-5.12 5.12H770.7648V481.8944h196.3008a5.12 5.12 0 0 1 5.12 5.12z"
      fill="#1296db"
      p-id="2433"
    ></path>
    <path
      d="M635.6992 292.5568h-67.1744V225.28a32.768 32.768 0 0 0-32.768-32.768h-60.7232a32.768 32.768 0 0 0-32.768 32.768v67.1744h-67.072a32.768 32.768 0 0 0-32.768 32.768v60.8256a32.768 32.768 0 0 0 32.768 32.768h67.2768v67.072a32.768 32.768 0 0 0 32.768 32.768h60.8256a32.768 32.768 0 0 0 32.768-32.6656V418.816h67.072a32.768 32.768 0 0 0 32.768-32.768v-60.7232a32.768 32.768 0 0 0-32.9728-32.768z m2.048 93.4912a2.048 2.048 0 0 1-2.048 2.048H552.96a15.36 15.36 0 0 0-15.36 15.36v82.432a2.048 2.048 0 0 1-2.048 2.048h-60.5184a2.048 2.048 0 0 1-2.048-2.048v-80.2816a14.9504 14.9504 0 0 0-15.1552-17.5104h-82.6368a2.048 2.048 0 0 1-2.048-2.048v-60.7232a2.048 2.048 0 0 1 2.048-2.048h81.92A16.0768 16.0768 0 0 0 472.9856 307.2v-81.92a2.048 2.048 0 0 1 2.048-2.048h60.8256a2.048 2.048 0 0 1 2.048 2.048V307.712a15.36 15.36 0 0 0 15.36 15.36h82.5344a2.048 2.048 0 0 1 2.048 2.048zM181.5552 727.4496h30.72v30.72h-30.72zM603.3408 669.0816h-189.44a15.36 15.36 0 0 0 0 30.72h189.44a15.36 15.36 0 1 0 0-30.72z"
      fill="#1296db"
      p-id="2434"
    ></path>
    <path
      d="M546.4064 879.0016m-15.36 0a15.36 15.36 0 1 0 30.72 0 15.36 15.36 0 1 0-30.72 0Z"
      fill="#1296db"
      p-id="2435"
    ></path>
    <path
      d="M474.7264 879.0016m-15.36 0a15.36 15.36 0 1 0 30.72 0 15.36 15.36 0 1 0-30.72 0Z"
      fill="#1296db"
      p-id="2436"
    ></path>
  </svg>
);
export const HospitalIcon = (props) => (
  <Icon component={HospitalSvg} {...props} />
);
const SchoolSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4170"
    width="16"
    height="16"
  >
    <path
      d="M576 944h-128a16 16 0 0 1-16-16v-224a16 16 0 0 1 16-16h128a16 16 0 0 1 16 16v224a16 16 0 0 1-16 16z m-112-32h96v-192h-96v192zM511.488 382.976a62.08 62.08 0 0 1-62.016-62.016 62.08 62.08 0 0 1 62.016-62.016 62.08 62.08 0 0 1 62.016 62.016 62.08 62.08 0 0 1-62.016 62.016z m0-92.032a30.048 30.048 0 1 0 0.032 60.064 30.048 30.048 0 0 0-0.032-60.064zM816 596.352h-96a16 16 0 0 1-16-16V464a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v116.352a16 16 0 0 1-16 16z m-80-32h64V480h-64v84.352zM816 800h-96a16 16 0 0 1-16-16v-116.352a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16V784a16 16 0 0 1-16 16zM736 768h64v-84.352h-64V768zM304 596.352h-96a16 16 0 0 1-16-16V464a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16v116.352a16 16 0 0 1-16 16z m-80-32h64V480H224v84.352zM304 800h-96a16 16 0 0 1-16-16v-116.352a16 16 0 0 1 16-16h96a16 16 0 0 1 16 16V784a16 16 0 0 1-16 16zM224 768h64v-84.352H224V768z"
      fill="#1296db"
      p-id="4171"
    ></path>
    <path
      d="M927.488 944h-832a16 16 0 0 1 0-32h832a16 16 0 0 1 0 32z"
      fill="#1296db"
      p-id="4172"
    ></path>
    <path
      d="M640 944h-256a16 16 0 0 1-16-16V204.512c0-4.672 2.016-9.12 5.568-12.128l126.496-108.512a16 16 0 0 1 20.704-0.128l129.504 108.512a15.904 15.904 0 0 1 5.728 12.256V928a16 16 0 0 1-16 16z m-240-32h224V212l-113.376-95.008L400 211.872V912z"
      fill="#1296db"
      p-id="4173"
    ></path>
    <path
      d="M896 944h-256a16 16 0 0 1-16-16V352a16 16 0 0 1 16-16h256a16 16 0 0 1 16 16v576a16 16 0 0 1-16 16z m-240-32h224v-544h-224v544zM384 944H128a16 16 0 0 1-16-16V352a16 16 0 0 1 16-16h256a16 16 0 0 1 16 16v576a16 16 0 0 1-16 16z m-240-32h224v-544h-224v544z"
      fill="#1296db"
      p-id="4174"
    ></path>
    <path
      d="M384 368H96a16.064 16.064 0 0 1-14.688-22.304l41.152-96a15.904 15.904 0 0 1 14.688-9.696H384a16 16 0 0 1 16 16v96a16 16 0 0 1-16 16z m-263.744-32H368v-64H147.68l-27.424 64zM928 368h-288a16 16 0 0 1-16-16V256a16 16 0 0 1 16-16h246.848c6.4 0 12.192 3.808 14.688 9.696l41.152 96A16.064 16.064 0 0 1 928 368z m-272-32h247.744l-27.424-64H656v64z"
      fill="#1296db"
      p-id="4175"
    ></path>
  </svg>
);
export const SchoolIcon = (props) => <Icon component={SchoolSvg} {...props} />;
const GradeSvg = () => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="6631"
    width="16"
    height="16"
  >
    <path
      d="M28.16 286.40256L505.6 101.12 998.4 286.40256 532.48 478.72z"
      fill="#1296db"
      p-id="6632"
    ></path>
    <path
      d="M512 512c-12.8 0-32 0-44.8-6.4L51.2 364.8c-32-12.8-51.2-44.8-51.2-76.8s19.2-64 51.2-76.8l409.6-140.8c32-12.8 64-12.8 96 0l409.6 140.8c38.4 12.8 57.6 44.8 57.6 76.8s-19.2 64-51.2 76.8l-416 140.8C544 512 524.8 512 512 512z m0-384c-6.4 0-19.2 0-25.6 6.4l-409.6 140.8c-12.8 0-12.8 6.4-12.8 12.8s0 12.8 12.8 12.8l409.6 140.8c19.2 6.4 32 6.4 51.2 0l409.6-140.8c12.8 0 12.8-6.4 12.8-12.8s0-12.8-12.8-12.8l-409.6-140.8C531.2 128 518.4 128 512 128z"
      fill="#1296db"
      p-id="6633"
    ></path>
    <path
      d="M723.2 864h-422.4c-76.8 0-140.8-64-140.8-140.8V384c0-19.2 12.8-32 32-32s32 12.8 32 32v339.2c0 44.8 32 76.8 76.8 76.8h428.8c38.4 0 76.8-38.4 76.8-76.8V384c0-19.2 12.8-32 32-32S870.4 364.8 870.4 384v339.2c-6.4 76.8-70.4 140.8-147.2 140.8zM960 832c-19.2 0-32-12.8-32-32v-384c0-19.2 12.8-32 32-32s32 12.8 32 32v384c0 19.2-12.8 32-32 32zM908.8 908.8c0 28.27776 22.92224 51.2 51.2 51.2s51.2-22.92224 51.2-51.2-22.92224-51.2-51.2-51.2-51.2 22.92224-51.2 51.2z"
      fill="#1296db"
      p-id="6634"
    ></path>
  </svg>
);
export const GradeIcon = (props) => <Icon component={GradeSvg} {...props} />;
const ClassSvg = () => (
  <svg
    viewBox="0 0 1442 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7588"
    width="16"
    height="16"
  >
    <path
      d="M1078.406833 729.15649H397.80044a5.376203 5.376203 0 0 0-5.341368 5.120746c-0.290292 5.132358-0.754759 10.276327-1.346953 15.408685a218.810299 218.810299 0 0 1-13.109575 51.300356 24.698021 24.698021 0 0 0 22.944659 33.755123h677.45963c22.874989 0 41.651058-18.183874 41.651058-40.640843v-24.280001c0-22.480192-18.578671-40.640843-41.651058-40.640843z m-594.517476-281.211411c1.579187-2.101712 9.660909-14.874549 11.240096-16.976261l113.213777-154.435203c13.934003-18.973468 10.949804-44.577199-6.641874-57.094579l-7.826266-5.666495c-17.591679-12.714778-42.963177-7.431468-56.89718 11.530388l-102.821333 140.385084a27.705443 27.705443 0 0 1-18.392884 10.973027L267.854247 398.049735a95.610486 95.610486 0 0 1-12.772836 0.383185l-19.426323-0.325126H173.637162c-5.805835 0.092893-9.742191 0-15.025501 0-13.295362 0-16.349231-0.150952-34.010579 0H98.16131c-54.168438 0-98.153442 43.61343-98.153442 97.189673v242.846455c0 43.090905 28.471813 79.133527 67.637975 91.848305a21.110015 21.110015 0 0 1 2.554567 1.010215c5.538766 2.612626 24.674798 4.319541 27.9609 4.319541h137.307991c54.168438 0 98.153442-43.601819 98.153442-97.178061v-218.763853a27.705443 27.705443 0 0 1 21.35386-26.962296l106.269999-25.034759q0.986992-0.232233 1.962372-0.534137c5.120746-1.590799 12.215476-3.483501 20.680383-18.903798m-317.056634-108.441381c65.118242 0 117.707493-52.252512 117.707493-116.534714S231.695509 106.376211 166.832723 106.376211c-65.118242 0-117.719105 52.252512-117.719104 116.546326s52.600863 116.581161 117.719104 116.581161m175.336209-119.275068a171.353406 171.353406 0 0 1-47.770408 118.58998 5.341368 5.341368 0 0 0 5.016241 8.871315h0.197398a442.160761 442.160761 0 0 1 81.943552-9.927977 23.478796 23.478796 0 0 0 18.369661-9.533181l101.091194-136.367446c29.923272-40.280881 84.660682-51.230686 122.410219-24.384506l16.999484 12.02969c37.749537 26.788121 44.194014 81.281686 14.282354 121.423227L524.077345 477.299379a151.265218 151.265218 0 0 1-10.218269 12.459322c-67.243178 73.559926-119.530525 5.42265-124.244863 87.296531v0.325126l-0.371573 85.589616a5.341368 5.341368 0 0 0 5.341368 5.364591h42.336147c20.482985 0.150952 40.280881 0 61.205109 0h236.738717c-19.159255 0-34.602775-15.09517-34.602775-33.824793v-23.664582c0-18.578671 15.44352-33.673841 34.602775-33.673842H868.014994c18.973468 0 34.614387 15.09517 34.614387 33.673842v23.65297c0 18.578671-15.455132 33.824793-34.614387 33.824793h112.435795c42.963177 0 77.798185-33.429996 77.798186-74.883656V74.885363c0-41.45366-34.835008-74.883656-77.798186-74.883656H202.225092a78.053642 78.053642 0 0 0-68.172112 39.131326 5.341368 5.341368 0 0 0 5.399427 7.895935 174.082148 174.082148 0 0 1 23.86198-1.660469c98.69919 0.197398 178.912603 78.216205 178.912603 174.802072"
      p-id="7589"
      fill="#1296db"
    ></path>
  </svg>
);
export const ClassIcon = (props) => <Icon component={ClassSvg} {...props} />;

export const isYounger = (age: number) => {
  if (age > 6) {
    return false;
  } else {
    return true;
  }
};
export const buildSampleResult = (s: ToothSample) => {
  let younger = isYounger(s.age);

  //let years = moment().diff(moment(s.Birthday), "years");
  let cat = 0;
  if (s.cat === -1) {
    return;
  } else {
    if (s.cat <= 0.5) {
      cat = 0;
    } else if (s.cat <= 1.5) {
      cat = 1;
    } else if (s.cat >= 2.0) {
      cat = 2;
    }
  }
  if (!younger) {
    if (s.a1 === "是" || s.c2 === "是" || s.c3 === "是" || cat === 2) {
      s.result = "高风险";
    } else if (s.a2 === "是" || cat === 1 || s.c5 === "是" || s.c4 === "是") {
      s.result = "中风险";
    } else {
      s.result = "低风险";
    }
  } else {
    if (
      s.a1 === "是" ||
      s.a2 === "是" ||
      s.a3 === "是" ||
      cat === 2 ||
      s.c2 === "是"
    ) {
      s.result = "高风险";
    } else if (s.a4 === "是" || cat === 1 || s.c3 === "是" || s.c4 === "是") {
      s.result = "中风险";
    } else {
      s.result = "低风险";
    }
  }
};

export const samples: ToothSample[] = [];
export const firstGetAllSamples = async () => {
  let data = await getAllSamples(); //大小写转换！！！！
  if (typeof data !== "undefined") {
    data.forEach((t) => samples.push({ ...t, key: t.id }));
  }
};
